export default __webpack_public_path__ + "static/media/subok.be945d49.svg";